export enum Colors {
    Success = "#099c64",
    Warning = "#f5af00",
    Error = "#c93936",
    Info = "#008bd6"
}
